/**
 * FT12-U18: Collection Effectiveness Index (FSD 2.2.3.10). The INT packet spreads
 * `AR_CEI_ROUTES` and adds the nav item `ar-cei`. The route's permission is the report
 * endpoint's: `ar.report.read`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { AR_PERMISSIONS } from '@/modules/ar/permissions'

export const AR_CEI_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ar/reports/cei',
    name: 'ar-cei',
    component: () => import('@/modules/ar/reports/cei/CeiReportView.vue'),
    meta: {
      titleKey: 'ar.routeTitles.cei',
      permission: AR_PERMISSIONS.reportRead,
    },
  },
]
